import MAAAA000 from '../../pages/Admin/MAAAA000';

import MABAA010 from '../../pages/Memember/MABAA010';
import MABAA020 from '../../pages/Memember/MABAA020';

import MACAA010 from '../../pages/Recruit/MACAA010';
import MACAA020 from '../../pages/Recruit/MACAA020';

import MADAA010 from '../../pages/Cv/MADAA010';
import MADAA020 from '../../pages/Cv/MADAA020';

import MAEAA010 from '../../pages/Banner/MAEAA010';
import MAEAA020 from '../../pages/Banner/MAEAA020';
import MAEAA030 from '../../pages/Banner/MAEAA030';

import MAFAA010 from '../../pages/Advertise/MAFAA010';
import MAFAA030 from '../../pages/Advertise/MAFAA030';
import MAFAA040 from '../../pages/Advertise/MAFAA040';
import MAFAA050 from '../../pages/Advertise/MAFAA050';
import MAFAA060 from '../../pages/Advertise/MAFAA060';
import MAFAA070 from '../../pages/Advertise/MAFAA070';
import MAFAA080 from '../../pages/Advertise/MAFAA080';

import MAGAA010 from '../../pages/Menu/MAGAA010';
import MAGAB010 from '../../pages/Menu/MAGAB010';
import MAGAB020 from '../../pages/Menu/MAGAB020';
import MAGAB030 from '../../pages/Menu/MAGAB030';
import MAGAC010 from '../../pages/Menu/MAGAC010';
import MAGAC020 from '../../pages/Menu/MAGAC020';
import MAGAC030 from '../../pages/Menu/MAGAC030';
import MAGAC040 from '../../pages/Menu/MAGAC040';
import MAGAC050 from '../../pages/Menu/MAGAC050';
import MAGAD010 from '../../pages/Menu/MAGAD010';
import MAGAE010 from '../../pages/Menu/MAGAE010';
import MAGAE020 from '../../pages/Menu/MAGAE020';
import MAGAE030 from '../../pages/Menu/MAGAE030';
import MAGAF010 from '../../pages/Menu/MAGAF010';
import MAGAF020 from '../../pages/Menu/MAGAF020';
import MAGAF030 from '../../pages/Menu/MAGAF030';
import MAGAG010 from '../../pages/Menu/MAGAG010';
import MAGAG020 from '../../pages/Menu/MAGAG020';
import MAGAG030 from '../../pages/Menu/MAGAG030';
import MAGAH010 from '../../pages/Menu/MAGAH010';
import MAGAI010 from '../../pages/Menu/MAGAI010';
import MAGAI020 from '../../pages/Menu/MAGAI020';
import MAGAT010 from '../../pages/Menu/MAGAT010';
import MAGAT020 from '../../pages/Menu/MAGAT020';

import MAIAA010 from '../../pages/Payment/MAIAA010';
import MAIAB010 from '../../pages/Payment/MAIAB010';
import MAIAC010 from '../../pages/Payment/MAIAC010';
import MAJAA000 from '../../pages/StatisticalManagement/MAJAA000';
import MAJAA010 from '../../pages/StatisticalManagement/MAJAA010';
import MAJAB010 from '../../pages/StatisticalManagement/MAJAB010';
import MAJAC010 from '../../pages/StatisticalManagement/MAJAC010';
import MAJAD010 from '../../pages/StatisticalManagement/MAJAD010';
import MAJAD020 from '../../pages/StatisticalManagement/MAJAD020';
import MAJAD030 from '../../pages/StatisticalManagement/MAJAD030';
import MAJAD040 from '../../pages/StatisticalManagement/MAJAD040';
import MAJAD050 from '../../pages/StatisticalManagement/MAJAD050';

const routersMain = [
    { path: '/maaaa000', element: MAAAA000 },
    { path: '/mabaa010', element: MABAA010 },
    { path: '/mabaa020', element: MABAA020 },
    { path: '/magab010', element: MAGAB010 },
    { path: '/magab020', element: MAGAB020 },
    { path: '/magab020-:id', element: MAGAB020 },
    { path: '/magab030-:id', element: MAGAB030 },
    { path: '/magac010', element: MAGAC010 },
    { path: '/magac020', element: MAGAC020 },
    { path: '/magac020-:id', element: MAGAC020 },
    { path: '/magac030-:id', element: MAGAC030 },
    { path: '/magac040-:id', element: MAGAC040 },
    { path: '/magac050', element: MAGAC050 },
    { path: '/magac050-:id', element: MAGAC050 },
    { path: '/magad010', element: MAGAD010 },
    { path: '/maeaa010', element: MAEAA010 },
    { path: '/maeaa020', element: MAEAA020 },
    { path: '/maeaa020-:id', element: MAEAA020 },
    { path: '/maeaa030-:id', element: MAEAA030 },
    { path: '/magae010', element: MAGAE010 },
    { path: '/magae020', element: MAGAE020 },
    { path: '/magae020-:id', element: MAGAE020 },
    { path: '/magae030-:id', element: MAGAE030 },
    { path: '/madaa010', element: MADAA010 },
    { path: '/madaa020-:id', element: MADAA020 },
    { path: '/magaf010', element: MAGAF010 },
    { path: '/magaf020', element: MAGAF020 },
    { path: '/magaf020-:id', element: MAGAF020 },
    { path: '/magaf030-:id', element: MAGAF030 },
    { path: '/magag010', element: MAGAG010 },
    { path: '/magag030-:id', element: MAGAG030 },
    { path: '/magag020-:id', element: MAGAG020 },
    { path: '/magag020', element: MAGAG020 },
    { path: '/magah010', element: MAGAH010 },
    { path: '/magah020-:id', element: MAGAI020 },
    { path: '/magai020-:id', element: MAGAI020 },
    { path: '/magai010', element: MAGAI010 },
    { path: '/mafaa010', element: MAFAA010 },
    { path: '/mafaa030', element: MAFAA030 },
    { path: '/macaa010', element: MACAA010 },
    { path: '/macaa020', element: MACAA020 },
    { path: '/mafaa040', element: MAFAA040 },
    { path: '/mafaa050', element: MAFAA050 },
    { path: '/mafaa060', element: MAFAA060 },
    { path: '/mafaa070', element: MAFAA070 },
    { path: '/mafaa080', element: MAFAA080 },
    { path: '/magaa010', element: MAGAA010 },
    { path: '/magat010', element: MAGAT010 },
    { path: '/magat020', element: MAGAT020 },
    { path: '/magat020-:id', element: MAGAT020 },
    { path: '/magad010', element: MAGAD010 },
    { path: '/maiaa010', element: MAIAA010 },
    { path: '/maiab010', element: MAIAB010 },
    { path: '/maiac010', element: MAIAC010 },
    { path: '/majaa000', element: MAJAA000 },
    { path: '/majaa010', element: MAJAA010 },
    { path: '/majab010', element: MAJAB010 },
    { path: '/majac010', element: MAJAC010 },
    { path: '/majad010', element: MAJAD010 },
    { path: '/majad020', element: MAJAD020 },
    { path: '/majad030', element: MAJAD030 },
    { path: '/majad040', element: MAJAD040 },
    { path: '/majad050', element: MAJAD050 },
];

export default routersMain;
